import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOffer Types */
import {
  _SupplierOffers,
  Settings
} from '../namespace-helper'

import _ from 'lodash'

const selectedSupplierOfferTemplate = {
  id: 0,
  documents_id: 0
}

export default {
  namespaced: true,
  state: {
    supplierOffer: null,
    selectedSupplierOffer: _.cloneDeep(selectedSupplierOfferTemplate),
    supplierOfferLoading: false,
    supplierOfferDocumentViewToken: null,
    openDialog: false
  },
  mutations: {
    [_SupplierOffers.mutations.setSupplierOffer] (state, payload) {
      state.supplierOffer = payload
    },
    [_SupplierOffers.mutations.setSelectedSupplierOffer] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOffer = payload
      } else {
        state.selectedSupplierOffer = _.cloneDeep(selectedSupplierOfferTemplate)
      }
    },
    [_SupplierOffers.mutations.setSupplierOfferDocumentViewToken] (state, payload) {
      if (payload !== null) {
        state.supplierOfferDocumentViewToken = payload
      } else {
        state.supplierOfferDocumentViewToken = null
      }
    },
    [_SupplierOffers.mutations.setLoadSupplierOffer] (state, payload) {
      state.supplierOfferLoading = payload
    },
    [_SupplierOffers.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_SupplierOffers.actions.saveSupplierOffer] (context, payload) {
      context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, true)

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOffers'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
            ErrorHandler.clear(store)
            context.commit(_SupplierOffers.mutations.setSupplierOffer, [r.data.data])
            context.commit(_SupplierOffers.mutations.setSelectedSupplierOffer, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOffers/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
            ErrorHandler.clear(store)
            context.commit(_SupplierOffers.mutations.setSupplierOffer, [r.data.data])
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOffers.actions.loadSupplierOfferByInquiryAndSupplierID] (context, payload) {
      context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, true)

      var url = API_URL + '/api/v1/supplierOffers/' + payload.inquiry_id + '/' + payload.supplier_id

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
        ErrorHandler.clear(store)
        context.commit(_SupplierOffers.mutations.setSupplierOffer, r.data.data)
      }, function (err) {
        context.commit(_SupplierOffers.mutations.setLoadSupplierOffer, false)
        context.commit(_SupplierOffers.mutations.setSupplierOffer, null)
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_SupplierOffers.actions.setSupplierOffer] (context, payload) {
      context.commit(_SupplierOffers.mutations.setSupplierOffer, [])
    },
    [_SupplierOffers.actions.setSelectedSupplierOffer] (context, payload) {
      context.commit(_SupplierOffers.mutations.setSelectedSupplierOffer, payload)
    },
    [_SupplierOffers.actions.getDocumentViewTokenBySupplierOfferId] (context, payload) {
      console.log('getDocumentViewTokenBySupplierOfferId: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/supplierOffers/documentToken/' + payload.id + '?filename=' + payload.filename

      store.commit(Settings.mutations.setLoading, true)
      return new Promise((resolve, reject) => {
        return axios.post(url, {}, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOffers.mutations.setSupplierOfferDocumentViewToken, r.data.data)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOffers.actions.openCloseDialog] ({ commit }) {
      commit(_SupplierOffers.mutations.setOpenCloseDialogState)
    },
    [_SupplierOffers.actions.resetState] ({ commit }) {
      commit(_SupplierOffers.mutations.setSupplierOffer, null)
      commit(_SupplierOffers.mutations.setSelectedSupplierOffer, null)
      commit(_SupplierOffers.mutations.setSupplierOfferDocumentViewToken, null)
    }
  },
  getters: {
    [_SupplierOffers.getters.getSupplierOffer] (state) {
      return state.supplierOffer
    },
    [_SupplierOffers.getters.getSelectedSupplierOffer] (state) {
      return state.selectedSupplierOffer
    },
    [_SupplierOffers.getters.getSupplierOfferDocumentToken] (state) {
      return state.supplierOfferDocumentViewToken
    },
    [_SupplierOffers.getters.getLoadingSupplierOffer] (state) {
      return state.supplierOfferLoading
    },
    [_SupplierOffers.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOffer/supplierOffers.js